import styled from 'styled-components';

export const Carousel = styled.div`
  min-height: 80vh;
`;

export const SpellCard = styled.div`
  border: 1px solid black;

  .spellName {
    display: inline-flex;
    padding: 5px;

    h2 {
      clear: none;
      text-align: left;
    }
  }

  hr {
    border: 2px solid black !important;
    margin: 0;
  }
`;
